import React from 'react';
import type { ReactElement } from 'react';
import { render } from '@wix/cli-ui-kit';
import { ErrorReporterProvider } from '@wix/cli-error-reporting';
import { BiProvider } from '@wix/cli-telemetry-react';
import type { CommandServices } from '@wix/cli-command-contract';
import type { Command } from '@commander-js/extra-typings';
import { reportCommandStartEvent } from '../bi.js';

export async function renderCommand(
  command: Command,
  { biLogger, errorReporter }: CommandServices,
  tree: ReactElement
) {
  await runCommand(command, { biLogger, errorReporter }, async () => {
    await render(
      <BiProvider value={biLogger}>
        <ErrorReporterProvider value={errorReporter}>
          {tree}
        </ErrorReporterProvider>
      </BiProvider>
    );
  });
}

async function runCommand(
  command: Command,
  services: CommandServices,
  commandFn: () => Promise<void>
) {
  const commandStatus = reportCommandStartEvent(services.biLogger, command);

  try {
    await commandFn();
    commandStatus.succeed();
  } catch (e) {
    commandStatus.failed(e);
    throw e;
  }
}
